<template>
  <div>
    <!-- -->
    新闻详情
  </div>
</template>

<script>
export default {
  name: 'HzydgwNewsDetail',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>